import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

// ── Champ de date « calendrier uniquement » ────────────────────────────────
// La saisie clavier est BLOQUÉE : la date ne peut être choisie que via le
// calendrier natif (aucune ambiguïté JJ/MM vs MM/JJ possible, quelle que soit
// la locale du navigateur). La date choisie est confirmée en toutes lettres
// sous le champ. La valeur émise est toujours au format ISO YYYY-MM-DD.
const LOCALES = { fr: 'fr-FR', en: 'en-GB', de: 'de-DE', sv: 'sv-SE' };

export default function DateField({ value, onChange, style, disabled, min, max, confirmColor = '#0F6E56' }) {
  const { lang } = useLanguage();
  const locale = LOCALES[lang] || 'fr-FR';

  // Confirmation en toutes lettres — parsing UTC pour garantir zéro décalage de fuseau.
  let pretty = '';
  const m = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    const d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));
    pretty = d.toLocaleDateString(locale, { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
  }

  return (
    <div>
      <input
        type="date"
        value={value || ''}
        disabled={disabled}
        min={min}
        max={max}
        onChange={e => onChange(e.target.value)}
        onKeyDown={e => e.preventDefault()}                                   // bloque la frappe clavier
        onPaste={e => e.preventDefault()}                                      // bloque le collage
        onClick={e => { try { e.target.showPicker && e.target.showPicker(); } catch (_) {} }} // ouvre le calendrier au clic
        style={{ ...style, caretColor: 'transparent', cursor: disabled ? 'default' : 'pointer' }}
      />
      {pretty && (
        <div style={{ fontSize: 11.5, color: confirmColor, marginTop: 3, fontWeight: 600 }}>
          = {pretty}
        </div>
      )}
    </div>
  );
}
